import React, { useState } from 'react';
import { Form, message, Button, Select } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const layout = {
	labelCol: {
		span: 10,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 10,
		span: 16,
	},
};

const InspectionEditForm = ({ fetchInspectionOrders, inspectionOrder, updateInspectionOrder, closeModal }) => {
	const onFinish = async (values) => {
		await updateInspectionOrder(inspectionOrder._id, values);
		fetchInspectionOrders();
		closeModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="InspectionForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item initialValue={inspectionOrder?.paymentStatus} label="Payment Status" name={['paymentStatus']}>
				<Select placeholder="Select Status">
					<Select.Option value={1}>Successful</Select.Option>
					<Select.Option value={0}>Pending</Select.Option>
					<Select.Option value={-1}>Failed</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Inspection Order
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	fetchInspectionOrders: () => dispatch(Actions.fetchInspectionOrders()),
	updateInspectionOrder: (id, body) => dispatch(Actions.updateInspectionOrder(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InspectionEditForm);
